// src/utils/profilePictureRegistry.js

// Static imports for better Safari compatibility and performance
import pp1 from '../images/profilePictures/pp1.webp';
import pp2 from '../images/profilePictures/pp2.webp';
import pp3 from '../images/profilePictures/pp3.webp';
import pp4 from '../images/profilePictures/pp4.webp';
import pp5 from '../images/profilePictures/pp5.webp';
import pp6 from '../images/profilePictures/pp6.webp';
import pp7 from '../images/profilePictures/pp7.webp';
import pp8 from '../images/profilePictures/pp8.webp';
import pp9 from '../images/profilePictures/pp9.webp';
import pp10 from '../images/profilePictures/pp10.webp';
import pp11 from '../images/profilePictures/pp11.webp';
import pp12 from '../images/profilePictures/pp12.webp';
import pp13 from '../images/profilePictures/pp13.webp';
import pp14 from '../images/profilePictures/pp14.webp';
import pp15 from '../images/profilePictures/pp15.webp';
import pp16 from '../images/profilePictures/pp16.webp';
import pp17 from '../images/profilePictures/pp17.webp';
import pp18 from '../images/profilePictures/pp18.webp';
import pp19 from '../images/profilePictures/pp19.webp';
import pp20 from '../images/profilePictures/pp20.webp';
import pp21 from '../images/profilePictures/pp21.webp';
import pp22 from '../images/profilePictures/pp22.webp';
import pp23 from '../images/profilePictures/pp23.webp';
import pp24 from '../images/profilePictures/pp24.webp';
import pp25 from '../images/profilePictures/pp25.webp';
import pp26 from '../images/profilePictures/pp26.webp';
import pp27 from '../images/profilePictures/pp27.webp';
import pp28 from '../images/profilePictures/pp28.webp';

/**
 * Static registry of all profile pictures
 * Replaces dynamic imports for better Safari compatibility
 */
export const PROFILE_PICTURES = {
  'pp1.webp': pp1,
  'pp2.webp': pp2,
  'pp3.webp': pp3,
  'pp4.webp': pp4,
  'pp5.webp': pp5,
  'pp6.webp': pp6,
  'pp7.webp': pp7,
  'pp8.webp': pp8,
  'pp9.webp': pp9,
  'pp10.webp': pp10,
  'pp11.webp': pp11,
  'pp12.webp': pp12,
  'pp13.webp': pp13,
  'pp14.webp': pp14,
  'pp15.webp': pp15,
  'pp16.webp': pp16,
  'pp17.webp': pp17,
  'pp18.webp': pp18,
  'pp19.webp': pp19,
  'pp20.webp': pp20,
  'pp21.webp': pp21,
  'pp22.webp': pp22,
  'pp23.webp': pp23,
  'pp24.webp': pp24,
  'pp25.webp': pp25,
  'pp26.webp': pp26,
  'pp27.webp': pp27,
  'pp28.webp': pp28,
};

/**
 * Get profile picture by path with fallback
 * @param {string} picturePath - Path like 'pp1.webp'
 * @returns {string} - Image URL
 */
export const getProfilePicture = (picturePath) => {
  return PROFILE_PICTURES[picturePath] || pp1; // fallback to pp1
};

/**
 * Get profile picture by number
 * @param {number} pictureNumber - Number between 1-28
 * @returns {string} - Image URL
 */
export const getProfilePictureByNumber = (pictureNumber) => {
  const path = `pp${pictureNumber}.webp`;
  return getProfilePicture(path);
};

/**
 * Get all available profile picture paths
 * @returns {string[]} - Array of all picture paths
 */
export const getAllProfilePicturePaths = () => {
  return Object.keys(PROFILE_PICTURES);
};

/**
 * Check if a profile picture path exists
 * @param {string} picturePath - Path to check
 * @returns {boolean} - Whether the path exists
 */
export const hasProfilePicture = (picturePath) => {
  return picturePath in PROFILE_PICTURES;
};